import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Avatar } from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
import { ArrowDropDownOutlined } from "@mui/icons-material";
import { BookingApi } from "../../../API/Apis/BookingApi";
import { createTheme, Theme, ThemeProvider } from "@mui/material/styles";
import theme, {
  formatThemeForReservedArea,
} from "../../../config/MuiColorThemes";

function CollapsibleNavbar(params) {
  const navigateTo = useNavigate();
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userId] = useState(localStorage.getItem("userID"));
  const [userData, setUserData] = useState<any>({});
  const [showProfileSubMenu, setShowProfileSubMenu] = useState(false);
  const [dynamicTheme, setDynamicTheme] = useState<Theme | null>(null);
  const isSmallScreen = window.innerWidth <= 768;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isActiveProfileSection =
    location.pathname === "/profile" || location.pathname === "/changePassword";

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    async function fetchTheme() {
      const dynamicPalette = await formatThemeForReservedArea();
      const theme = createTheme(dynamicPalette);
      setDynamicTheme(theme);
    }
    fetchTheme();
  }, []);
  useEffect(() => {
    if (userId != null && userId != "null" && userId != "") {
      BookingApi.getUserProfileByUserId(parseInt(userId)).then((e) => {
        if (e.data.status == "Not Found") {
          alert(e.data.msg);
        } else {
          setUserData(e.data?.onlineUser[0]);
        }
      });
    }
  }, [userId]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleProfileSubMenu = () => {
    setShowProfileSubMenu(!showProfileSubMenu);
  };

  function handleLogout() {
    localStorage.setItem("isUserLoggedin", "false");
    localStorage.removeItem("userID");
    localStorage.removeItem("customerId");
    navigateTo("/signin");
  }

  return (
    <ThemeProvider theme={dynamicTheme || theme}>
      <div>
        <AppBar
          position="static"
          style={{
            width: "20%",
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            marginTop:
              isSmallScreen && params.callFrom == "showVehicle"
                ? "-55px"
                : "0px",
          }}
        >
          <Toolbar>
            <IconButton edge="start" aria-label="menu" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
            <label
              className="whitespace-nowrap"
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "x-large",
              }}
            >
              {params.callFrom == "dashboard" && "Book Your Vehicle"}
            </label>
          </Toolbar>
        </AppBar>
        <Drawer
          anchor="left"
          open={isDrawerOpen}
          onClose={toggleDrawer}
          PaperProps={{ style: { width: "300px" } }}
        >
          <List>
            <ListItem
              style={{
                marginTop: "40px",
                marginBottom: "",
                justifyContent: "center",
              }}
              className="flex-wrap"
            >
              <Avatar
                className=""
                alt={`${userData?.firstName}`}
                src={
                  userData?.profile_picture
                    ? userData?.profile_picture
                    : userData?.firstName
                }
              />
              {/*<ListItemText*/}
              {/*  primary={*/}
              {/*    <span*/}
              {/*      style={{*/}
              {/*        width: "10%",*/}
              {/*        display: "flex",*/}
              {/*        alignItems: "center",*/}
              {/*        flexWrap: "wrap",*/}
              {/*      }}*/}
              {/*      className={`text-[#000] font-poppins_regular text-[20px]`}*/}
              {/*    >*/}
              {/*      {userData?.firstName + " " + userData?.lastName}*/}
              {/*    </span>*/}
              {/*  }*/}
              {/*/>*/}
            </ListItem>
            <ListItem style={{ marginTop: "" }}>
              <ListItemText
                primary={
                  <span
                    style={{
                      // width: "10%",
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                    className={`text-[#000] font-poppins_regular text-[20px]`}
                  >
                    {userData?.firstName + " " + userData?.lastName}
                  </span>
                }
              />
            </ListItem>
            <hr />
            <ListItem style={{ marginTop: "20px" }}>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className={`h-6`}
                  src="/assets/images/createBooking.png"
                  alt="CreateBooking"
                />

                <span className="ml-5">{t("CreateBooking")}</span>
              </NavLink>
            </ListItem>
            <ListItem>
              <NavLink
                to="/customerDetailsList"
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/customer.details.png"
                  alt="CustomerDetails"
                />
                <span className="ml-5">{t("Customer Details")}</span>
              </NavLink>
            </ListItem>

            <ListItem>
              <NavLink
                to="/myReservedBookings"
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/bookingicon.png"
                  alt="List of reservation"
                />
                <span className="ml-5">{t("List of reservation")}</span>
              </NavLink>
            </ListItem>

            <ListItem>
              <NavLink
                to="/myInvoices"
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/invoiceicon.png"
                  alt="List of invoice"
                />

                <span className="ml-5"> {t("List of invoice")}</span>
              </NavLink>
            </ListItem>
            <List>
              <ListItem
                onClick={toggleDropdown}
                className={`nav-item flex items-center gap-2 ${
                  isActiveProfileSection ? "active" : ""
                }`}
              >
                <img
                  className={`h-6`}
                  src="/assets/images/profile.png"
                  alt="My Profile"
                />
                <span
                  style={{
                    marginLeft: "22px",
                    color: "primary",
                    fontWeight: "bold",
                  }}
                >
                  {t("My Profile")}
                </span>
                <ArrowDropDownOutlined
                  style={{ marginLeft: "auto", cursor: "pointer" }}
                  onClick={toggleProfileSubMenu}
                />
              </ListItem>

              {isDropdownOpen && (
                <>
                  <ListItem>
                    <NavLink
                      to="/profile"
                      className={({ isActive }) =>
                        isActive ? "nav-item active" : "nav-item"
                      }
                    >
                      <span className="ml-12">{t("Personal information")}</span>
                    </NavLink>
                  </ListItem>
                  <ListItem>
                    <NavLink
                      to="/changePassword"
                      className={({ isActive }) =>
                        isActive ? "nav-item active" : "nav-item"
                      }
                    >
                      <span className="ml-12">{t("Change Password")}</span>
                    </NavLink>
                  </ListItem>
                </>
              )}
            </List>
            <ListItem>
              <NavLink
                to="/signin"
                onClick={handleLogout}
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/logout.png"
                  alt="Logout"
                />
                <ListItemText
                  style={{ marginLeft: "23px" }}
                  primary={t("Logout")}
                />
              </NavLink>
            </ListItem>
          </List>
        </Drawer>
      </div>
    </ThemeProvider>
  );
}

export default CollapsibleNavbar;
